module.exports = __webpack_public_path__ + "img/Lobby_Banner3.0184cff9.jpg";